import {
  AuthSchemas,
  UserPreferencesSchemas,
  UserSchemas,
} from "@/domain/entities-new/user/user.schemas";
import { generateDTOWithZod } from "@/lib/utils";

// * Auth Validations
const authTokensFromAPI = (authTokens: unknown) =>
  generateDTOWithZod(
    AuthSchemas.AuthTokens,
    authTokens,
    "Invalid Auth Tokens received from API"
  );

// * User Validations
const userFromAPI = (user: unknown) =>
  generateDTOWithZod(UserSchemas.User, user, "Invalid User received from API");

// * User Preferences Validations
const userPreferencesFromAPI = (userPreferences: unknown) =>
  generateDTOWithZod(
    UserPreferencesSchemas.UserPreferences,
    userPreferences,
    "Invalid User Preferences received from API"
  );

// * Exporting all the validators
const AuthValidator = {
  AuthTokens: {
    fromAPI: authTokensFromAPI,
  },
};

const UserValidator = {
  User: {
    fromAPI: userFromAPI,
  },
};

const UserPreferencesValidator = {
  UserPreferences: {
    fromAPI: userPreferencesFromAPI,
  },
};

export { AuthValidator, UserValidator, UserPreferencesValidator };
